<template>
	<div class="head">
		<div class="head-center">
			<div class="logo"><img :src="logo"><span>巨人校园</span></div>
			<div class="menu" @click="down_menu"><i :class="downicon"></i></div>
		</div>
	</div>
	<div class="down-menu" v-if="downmenu">
		<ul>
			<li><a :href="rooturl+'index.php?s=videos&c=category&id=1'">游戏视频</a></li>
			<li><a :href="rooturl+'index.php?s=piaoliu&type=huati'">匿名小纸条</a></li>
			<li><a :href="rooturl+'index.php?s=piaoliu'">漂流瓶</a></li>
			<li><a :href="rooturl+'index.php?s=daiqu&c=category&id=1'">包裹代取</a></li>
			<li><a :href="rooturl+'index.php?s=ershou&c=category&id=1'">二手市场</a></li>
		</ul>
	</div>
	<div class="main">

		<div class="hot">

			<div class="video-play onzhibo" style="min-height:200px;" v-show="url">
				<div class="tips"><span></span><span>当前直播中</span></div>
				<div id="mse"></div>
			</div>

			<div class="video-play offzhibo" style="min-height:240px;" v-show="!url">
				<div class="tips"><span></span><span>当前未直播</span></div>
			</div>

			<div class="danmus" v-show="url && !isFullscreen">
				<div class="danmu-center">
					<input v-model="newDanmuTxt" placeholder="输入弹幕内容" @keyup.enter="sendDanmu" />
					<button @click="sendDanmu">发送</button>
				</div>
			</div>

		</div>
		<div class="danmusfullscreen" v-show="url && isFullscreen">
			<div class="danmu-center">
				<input v-model="newDanmuTxt" placeholder="输入弹幕内容" @keyup.enter="sendDanmu" />
				<button @click="sendDanmu">发送</button>
			</div>
		</div>
		<div class="carts-switch" @click="cart_switch(1)" v-show="url && cartswitch">
			<img src="../assets/yellow.png">
		</div>
		<div class="carts" v-show="cartbottm">
			<div class="carts-control">
				<span class="carts-title">{{sitename}}的商品橱窗<i class="icon-zdchevron-right1"></i></span>
				<div class="carts-control-group">
					<span class="carts-che">
						<i class="icon-zdshopping-cart"></i>
						<a :href="rooturl+'index.php?s=store&c=cart'" target="_blank">购物车</a>
					</span>
					<span class="carts-order">
						<i class="icon-zdclipboard2"></i>
						<a :href="rooturl+'index.php?s=member&app=store&c=order'" target="_blank">订单</a>
					</span>
				</div>
			</div>
			<ul>
				<li v-for="(products, item) in shoplist" :key="item">
					<a :href="products.url" target="_blank">
						<div class="carts-left"><img :src="products.thumb[0].url"></div>
						<div class="carts-right">
							<h3>{{products.title}}</h3>
							<p class="goods-desc">{{products.description}}</p>
							<p class="goods-price">￥{{products.price}}<span
									class="goods-nums">仅剩{{products.price_quantity}}件</span><button>去抢购</button></p>

						</div>
					</a>
				</li>
			</ul>
			<div class="carts-close" @click="cart_switch(0)">
				<i class="icon-zdchevrons-down"></i>
			</div>
		</div>

		<h3 class="tit">精彩视频</h3>
		<div class="video-list">
			<ul class="video-list-ul" v-if="vlist">
				<li v-for="(videos, item) in vlist" :key="item">
					<a :href="videos.url" target="_blank">
						<div class="v-list-img"><img :src="videos.thumb"></div>
						<div class="v-list-info">
							<h3>{{videos.title}}</h3>
							<p>发布日期：{{videos.updatetime}}</p>
						</div>
					</a>
				</li>
			</ul>
		</div>

		<div class="bottom"></div>

		<div class="foot">
			<ul>
				<li class="active">
					<a :href="rooturl">
						<i class="icon-zdhome1"></i>
						<p>首页</p>
					</a>
				</li>
				<li>
					<a :href="rooturl+'index.php?s=piaoliu&type=huati'">
						<i class="icon-zdtwitch1"></i>
						<p>纸条</p>
					</a>
				</li>
				<li>
					<a :href="rooturl+'index.php?s=daiqu'">
						<i class="icon-zdpackage"></i>
						<p>代取</p>
					</a>
				</li>
				<li>
					<a :href="rooturl+'index.php?s=ershou'">
						<i class="icon-zdcoffee"></i>
						<p>闲置</p>
					</a>
				</li>
				<li>
					<a :href="rooturl+'index.php?s=member'">
						<i class="icon-zduser1"></i>
						<p>我的</p>
					</a>
				</li>
			</ul>
		</div>
	</div>




</template>

<script>
	//import { toRaw } from 'vue';
	import axios from 'axios';
	import Player from 'xgplayer'; // 引入 Player 类
	import HlsPlugin from 'xgplayer-hls'; // 引入 HLS 插件
	import Danmu from 'xgplayer/es/plugins/danmu'; // 引入弹幕插件
	import 'xgplayer/dist/index.min.css';
	import 'xgplayer/es/plugins/danmu/index.css';
	import '../assets/style.css';
	import {
		I18N
	} from 'xgplayer';
	import ZH from 'xgplayer/es/lang/zh-cn';

	export default {
		data() {
			return {
				domid: 'mse', // 播放器容器的 id
				url: '', // HLS 地址
				danmu: {
					comments: [],
					area: {
						start: 0,
						end: 1
					},
					closeDefaultBtn: true,
					defaultOff: false,
					panel: true,
				},
				player: null,
				newDanmuTxt: '',
				logo: '',
				downmenu: false,
				downicon: 'icon-zdalign-right',
				sitename: '',
				rooturl: '',
				cart: '',
				cartbottm: false,
				cartswitch: true,
				vlist: '',
				shoplist: '',
				lastDanmuTime: 0, // 添加这个字段来记录最后一次获取弹幕的时间
				existingDanmuIds: new Set(), // 添加这个来跟踪已有的弹幕ID
				isFullscreen: false, // 添加全屏状态标记
			};
		},
		mounted() {
			I18N.use(ZH);
			this.get_data();

			// 更频繁地检查新弹幕
			setInterval(() => {
				if (this.player && this.player.plugins.danmu) {
					this.getDanmus();
				}
			}, 5000);
		},
		methods: {
			// 初始化播放器
			Hlsplayer() {
				this.player = new Player({
					id: this.domid, // 播放器容器 id
					url: this.url.replace(/&amp;/g, '&'), // HLS 流地址
					width: '100%',
					height: '100%',
					controls: {
						mode: 'normal',
					},
					videoAttributes: {
						'id': 'jrplayer',
						'style': 'width:100%;height:100%;position: absolute;top: 0;left: 0;',
					},
					fullscreen: {
						useCssFullscreen: true // 全屏按钮将会调用页面内全屏
					},
					autoplay: true,
					fluid: true,
					playsinline: true,
					'x5-video-player-fullscreen': true,
					plugins: [HlsPlugin, Danmu], // 加载插件
					danmu: this.danmu, // 配置弹幕
					lang: 'zh'
				});

				// 监听播放器错误事件
				this.player.on('error', (err) => {
					console.error('播放器加载错误：', err);
				});

				// 使用 MutationObserver 监听播放器元素的 class 变化
				const playerElement = document.getElementById(this.domid);
				const observer = new MutationObserver((mutations) => {
					mutations.forEach((mutation) => {
						if (mutation.attributeName === 'class') {
							const hasFullscreenClass = playerElement.classList.contains(
								'xgplayer-is-cssfullscreen');
							console.log('CSS全屏状态:', hasFullscreenClass);
							this.isFullscreen = hasFullscreenClass;
						}
					});
				});

				// 配置观察选项
				observer.observe(playerElement, {
					attributes: true,
					attributeFilter: ['class']
				});
			},

			// 获取所弹幕
			async getDanmus() {
				try {
					const response = await axios.get(
						`https://www.jurenxy.com/api/danmu_get.php?lastTime=${this.lastDanmuTime}`);
					if (response.data.code === 0) {
						// 如果有新弹幕
						if (response.data.data.length > 0) {
							// 过滤并只添加新的弹幕
							const newDanmus = response.data.data.filter(danmu => !this.existingDanmuIds.has(danmu.id));

							newDanmus.forEach(danmu => {
								// 添加到已存在的弹幕ID集合中
								this.existingDanmuIds.add(danmu.id);

								// 添加到弹幕列表
								this.danmu.comments.push(danmu);

								// 立即发送到播放器显示
								if (this.player && this.player.plugins.danmu) {
									// 调整弹幕的开始时间为当前播放时间
									const currentTime = this.player.currentTime * 1000;
									const adjustedDanmu = {
										...danmu,
										start: currentTime
									};
									this.player.plugins.danmu.sendComment(adjustedDanmu);
								}
							});
						}
						// 更新后获取���间
						this.lastDanmuTime = response.data.currentTime;
					}
				} catch (error) {
					console.error('获取弹幕失败:', error);
				}
			},

			// 修改 sendDanmu 方法
			async sendDanmu() {
				if (!this.newDanmuTxt.trim()) {
					alert("请输入弹幕内容");
					return;
				}

				const currentTime = this.player ? this.player.currentTime * 1000 : 0;
				const danmuId = String(Date.now());

				const newDanmu = {
					duration: 15000,
					id: danmuId,
					start: currentTime,
					txt: this.newDanmuTxt,
					mode: "scroll",
					style: {
						color: '#ffcc00',
						fontSize: '2rem',
						padding: '5px 11px',
					},
				};

				try {
					const response = await axios.post('https://www.jurenxy.com/api/danmu_save.php', newDanmu);
					if (response.data.status === 'success') {
						// 添加到已存在的弹幕ID集合中
						this.existingDanmuIds.add(danmuId);

						// 添加到弹幕队列
						this.danmu.comments.push(newDanmu);

						// 发送弹幕到播放器
						if (this.player && this.player.plugins.danmu) {
							this.player.plugins.danmu.sendComment(newDanmu);
						}

						this.newDanmuTxt = ''; // 清�������入框

						// 立��取一次新弹幕
						await this.getDanmus();
					}
				} catch (error) {
					console.error('发送弹幕失败:', error);
					alert('发送弹幕失败，请重试');
				}
			},

			// 获取站点数据
			get_data() {
				// 请求数据
				axios
					.get('https://www.jurenxy.com/index.php?s=videos&c=home&m=site_info') // 替换为你的接口地址
					.then((response) => {
						this.url = response.data.zburl; // 获取 HLS 地址
						this.logo = response.data.SITE_LOGO;
						this.sitename = response.data.SITE_NAME;
						document.title = this.sitename;
						this.rooturl = response.data.rooturl;
						this.Hlsplayer(); // 初始化播放器
						this.get_videodata();
						this.get_shopdata()
					})
					.catch((error) => {
						console.error('接口请求失败:', error);
					});
			},
			get_videodata() {
				// 请求视频列表数
				axios
					.get('https://www.jurenxy.com/index.php?s=videos&c=home&m=video_list') // 替换为你的接口地址
					.then((response) => {
						this.vlist = response.data;
					})
					.catch((error) => {
						console.error('接口请求失败:', error);
					});
			},
			get_shopdata() {
				// 请求视频列表数
				axios
					.get('https://www.jurenxy.com/index.php?s=videos&c=home&m=shop_list') // 替换为你的接口地址
					.then((response) => {
						this.shoplist = response.data;
					})
					.catch((error) => {
						console.error('接口请求失败:', error);
					});
			},
			cart_switch(e) {
				if (e === 1) {
					this.cartbottm = true;
					this.cartswitch = false;
				} else {
					this.cartbottm = false;
					this.cartswitch = true;
				}
			},
			down_menu() {
				if (this.downmenu === false) {
					this.downmenu = true;
					this.downicon = 'icon-zdchevron-up';
				} else {
					this.downmenu = false;
					this.downicon = 'icon-zdalign-right';
				}
			},
		},
		beforeUnmount() {
			// 在组件销毁时销毁播放器实例
			if (this.player) {
				this.player.destroy();
			}
		}
	};
</script>

<style>
	/* 全屏时的弹幕输入框样式 */
	.danmusfullscreen {
		position: fixed !important;
		bottom: 60px !important;
		left: 50% !important;
		transform: translateX(-50%) !important;
		width: 100% !important;
		max-width: 600px !important;
		z-index: 99999 !important;
		/* 默认隐藏 */
	}

	/* 全屏时显示 */
	.xgplayer-cssfullscreen~.danmusfullscreen {
		display: block !important;
	}

	.danmusfullscreen {
		background: rgba(0, 0, 0, 0.6);
		display: flex;
		gap: 10px;
		align-items: center;
		opacity: 0.5;
	}

	.danmusfullscreen.danmu-center {
		background: rgba(0, 0, 0, 0.6);
		border-radius: 6px;
		padding: 10px;
		display: flex;
		gap: 10px;
		align-items: center;
	}

	.danmusfullscreen input {
		flex: 1;
		height: 36px;
		padding: 0 15px;
		border: none;
		border-radius: 6px 0 0 6px;
		background: rgba(255, 255, 255, 0.9);
		color: #333;
		font-size: 14px;
		outline: none;
	}

	.danmusfullscreen button {
		height: 32px;
		padding: 0 20px;
		border: none;
		border-radius: 0 6px 6px 0;
		background: #ffcc00;
		color: #000;
		font-size: 14px;
		cursor: pointer;
		white-space: nowrap;
	}

	.danmusfullscreen button:hover {
		background: #ffd700;
	}
</style>